module.exports = __webpack_public_path__ + "vue/img/icon-06.6cda4e8b.png";